import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestScannerResultExternalsGet = {
    path: "/scanner/result/externals",
    method: RouteHttpVerb.GET
};
